import { Component } from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';

import Icon, { icons, IconText } from '../generic/Icon';

interface IModalWizardState {
  step?: number;
}

interface IModalWizardProps {
  title?: string;
  initStep?: number;
  canNextStep?: (currentStep: number) => boolean;
  canPrevStep?: (currentStep: number) => boolean;
  showStep?: (step: number) => boolean; // Allows callers to skip steps
  nextStepText?: string;
  finishText?: any; // node
  onFinish?: () => any;
  stepNames?: string[];
  show?: boolean;
  onHide: Function;
}

class ModalWizard extends Component<IModalWizardProps, IModalWizardState> {
  static defaultProps = {
    canNextStep() {
      return true;
    },
    canPrevStep() {
      return true;
    },
    showStep() {
      return true;
    },
    nextStepText: 'Next Step',
    finishText: 'Finish',
    onFinish() {},
    stepNames: [],
  };
  constructor(props) {
    super(props);
    this.state = {
      step: props.initStep || 1,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show) this.setState({ step: this.props.initStep || 1 });
  }
  _prevStep = () => {
    if (this.state.step <= 1) return;
    this.setState({ step: this.state.step - 1 });
  };
  _nextStep = () => {
    const children = this._getFilteredChildren();
    if (this.state.step >= children.length) {
      if (this.props.onFinish() === false) return;
      this.props.onHide();
      return;
    }
    this.setState({ step: this.state.step + 1 });
  };

  _getFilteredChildren() {
    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    return children.filter((_child, i) => this.props.showStep?.(i + 1));
  }

  shouldComponentUpdate(nextProps) {
    return this.props.show || this.props.show != nextProps.show;
  }
  onKeyDown = ev => {
    if (ev.which == 37) {
      this._prevStep();
    } else if (ev.which == 39) {
      this._nextStep();
    }
  };
  render() {
    var nav_items = [],
      next_validator_results = this.props.canNextStep(this.state.step),
      prev_validator_results = this.props.canPrevStep(this.state.step),
      canNextStep = next_validator_results === true,
      canPrevStep = this.state.step > 1 && prev_validator_results === true,
      children = this._getFilteredChildren();

    for (var i = 1; i <= children.length; i++) {
      nav_items.push(
        <li className={this.state.step >= i ? 'active' : ''} key={'wiz-nav-step' + i}>
          <a>{this.props.stepNames[i - 1] ? i + '. ' + this.props.stepNames[i - 1] : 'Step ' + i}</a>
        </li>,
      );
    }
    return (
      <Modal {...this.props} className="wizard" onKeyDown={this.onKeyDown}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="container-fluid">
          {nav_items.length > 1 ? (
            <div className="col-md-3 wizard-nav">
              <ul className="nav">{nav_items}</ul>
            </div>
          ) : (
            ''
          )}
          <div className={(nav_items.length > 1 ? 'col-md-9' : '') + ' wizard-content'}>
            {this.props.show ? children[this.state.step - 1] : ''} {/* TODO: delay the child unmounts */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {children.length > 1 ? (
            <Button onClick={this._prevStep} className="pull-left" disabled={!canPrevStep}>
              <IconText
                text="Prev Step"
                icon={icons.arrowLeft}
              />
            </Button>
          ) : (
            ''
          )}
          {typeof prev_validator_results === 'string' ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="prevValidatorTooltip">{prev_validator_results}</Tooltip>}>
              <a className="pull-left" style={{ padding: '7px' }}>
                <Icon icon={icons.questionCircle} />
              </a>
            </OverlayTrigger>
          ) : (
            ''
          )}
          <Button
            onClick={this._nextStep}
            className="pull-right wizard-next-step"
            disabled={!canNextStep}
            bsStyle={canNextStep ? 'primary' : 'default'}>
            {this.state.step < children.length ? (
              <span>
                <IconText
                  icon={icons.arrowRight}
                  text={this.props.nextStepText}
                  alignIcon="right"
                />
              </span>
            ) : (
              this.props.finishText
            )}
          </Button>
          {typeof next_validator_results === 'string' ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="nextValidatorTooltip">{next_validator_results}</Tooltip>}>
              <a className="pull-right" style={{ padding: '7px' }}>
                <Icon icon={icons.questionCircle} />
              </a>
            </OverlayTrigger>
          ) : (
            ''
          )}
          {children.length > 1 ? (
            <p className="text-center subtitle nomargin-v">
              Step {this.state.step}/{children.length}
            </p>
          ) : (
            ''
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalWizard;
